exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-buttons{display:flex;height:4rem;text-align:center;width:100%}.user-buttons__btn{color:beige;cursor:pointer;flex:1;font-size:2rem;height:100%;line-height:4rem}.user-buttons__btn--true{background-color:#24cca8}.user-buttons__btn--false{background-color:#ff3f33}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/Game/userButtons.scss
// module id = 224
// module chunks = 0